module.exports = {"twittersite":"@PaulGowder","twittercard":"summary","title":"Paul Gowder","image":"https://gowder.io/square.jpg","description":"Paul Gowder, Professor of Law at Northwestern University. Research and teaching in Constitutional Law, Political Science, Computational Legal Studies, Political Philosophy, Law and Technology, Platform Governance, Ethics, Rule of Law, Critical Race Theory, Classical Law and Democracy.","charset":"utf-8","viewport":"width=device-width, initial-scale=1","url":"https://gowder.io"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/metadata.json
// module id = 225
// module chunks = 0